import { KalturaKeyValue } from '@kaltura-ott/ott-client-types/api/types/KalturaKeyValue';

import { CachingServiceImpl, LaunchdarklyClient } from '../../interfaces';
import { KuxError } from '../errors';
import { ssoClientInvoke } from '../sso-client';

export interface UserServiceTariff {
  id: string;
  name: string;
}

interface AppParams {
  debugMenu?: boolean;
  isOffline?: boolean;
  cacheService: CachingServiceImpl;
  release: string;
  udid: string;
  useParentalPinStoreDepreciated?: boolean;
  featureEnabledOptions: {
    ffClient: LaunchdarklyClient;
  };
  dmsSetting: {
    clientTag: string;
    endpoint: string;
    applicationName: string;
    clientVersion: string;
    platform: string;
    tag: string;
    partnerId: number;
  };
  deviceAttributes: {
    name: string;
    brandId: number;
    firmware: string;
    osVersion: string;
    osName?: string;
    deviceManufacturer?: string | null;
    deviceModel?: string;
  };
  designParams: {
    epgScreenLength: number;
    defaultSizeIndex: number;
    imageScale: number;
  };
  poEditor?: {
    exportProjectPoeditorAPI: string;
    poEditorToken: string;
    projectId: string;
    proxy?: string;
  };
  silentLoginParams?: {
    serialNumber?: string;
    ip?: string;
    macLan?: string;
    macWiFi?: string;
    WEBSLID?: string;
    UDID?: string;
  };
}

export class ServicesListService {
  private static CHUNK_SIZE = 100;
  private currentPage = 0;
  private totalSize = 0;

  private ks;
  private bearer?: string;
  private params?: AppParams;

  constructor(ks: string) {
    this.ks = ks;
  }

  private fetchPage(pageNum = 0) {
    if (!this.bearer || !this.params) {
      throw new KuxError('Service list error', 500);
    }

    return ssoClientInvoke(this.params.dmsSetting.partnerId, {
      intent: 'Service List',
      adapterData: [
        new KalturaKeyValue({
          key: 'access_token',
          value: this.bearer,
        }),
        new KalturaKeyValue({
          key: 'pageIndex',
          value: pageNum.toString(),
        }),
        new KalturaKeyValue({
          key: 'pageSize',
          value: ServicesListService.CHUNK_SIZE.toString(),
        }),
      ],
    }).then((result): UserServiceTariff[] => {
      if (result.message === 'Error' && result.code) {
        throw new KuxError('Service list error', result.code);
      }

      let servicesList = [];
      if (result.adapterData?.totalCount) {
        this.totalSize = parseInt(result.adapterData.totalCount);
      }
      if (result.adapterData?.service_list) {
        servicesList = JSON.parse(result.adapterData.service_list)?.ServicesList;
      }
      // @ts-expect-error TODO Fix
      return servicesList?.map((service) => ({
        id: String(Object.values(service)[0]),
        name: Object.keys(service)[0],
      }));
    });
  }

  public setBearer(bearer: string) {
    this.bearer = bearer;
  }

  public setParams(params: AppParams | undefined) {
    this.params = params;
  }

  public fetchNext() {
    const page = this.fetchPage(this.currentPage);
    this.currentPage++;
    return page;
  }

  public hasMore(): boolean {
    return this.currentPage * ServicesListService.CHUNK_SIZE <= this.totalSize;
  }

  public reset() {
    this.currentPage = 0;
  }
}
